import {
  Company,
  CompanyType,
  IdentityParameter,
  PageNumberBasedListRequest,
  PageNumberBasedListResponse,
} from "@/features/types";
import useFetcher from "@/utils/use-fetcher";
import { Identity } from "@/features/ui/hooks/use-identity";
import {
  isIdentity,
  toIdentityParameter,
} from "@/features/ui/helpers/identity-helpers";
import { getUrlPrefixByIdentityParameter } from "@/features/ui/helpers/zwr-helpers";
import useSWR, { SWRConfiguration } from "swr";
import { IssuedTo } from "@/features/invoices/triangular-trades/triangular-trade.type";
//
// export interface ListIssuedToListWithoutPagingRequest {
//   type__in?: CompanyType[];
// }

export interface ListIssuedToListRequest extends PageNumberBasedListRequest {}

export interface ListIssuedToListResponse extends PageNumberBasedListResponse {
  issuedToList: IssuedTo[];
}

export interface ListIssuedToListPathParameter extends IdentityParameter {}

export function getListIssuedToListPathParameter(
  identity: Identity | null
): ListIssuedToListPathParameter | null {
  return toIdentityParameter(identity);
}

export function getListIssuedToListKey(
  identityOrParameter?: Identity | ListIssuedToListPathParameter | null,
  request?: ListIssuedToListRequest
) {
  if (identityOrParameter) {
    let parameter;
    if (isIdentity(identityOrParameter)) {
      parameter = getListIssuedToListPathParameter(identityOrParameter)!!;
    } else {
      parameter = identityOrParameter;
    }
    const prefix = getUrlPrefixByIdentityParameter(parameter);
    return {
      url: `${prefix}/issued_to`,
      params: request,
    };
  }
  return null;
}

export default function useListIssuedToList(
  parameter?: ListIssuedToListPathParameter | null,
  request?: ListIssuedToListRequest,
  config?: SWRConfiguration
) {
  const fetcher = useFetcher<
    ListIssuedToListRequest,
    ListIssuedToListResponse
  >();
  return useSWR(getListIssuedToListKey(parameter, request), fetcher, config);
}
